import createIcon from '../../createIcon';

/**
 * @component @name TempleHindu
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNi42IDExLjVIMTcuNEwxNi41IDguNUg3LjVMNi42IDExLjVaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMjAgMTEuNVYxMy41SDRWMTEuNUgyVjIyLjVIMTBWMTcuNUgxNFYyMi41SDIyVjExLjVIMjBaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMTUuOSA2LjVMMTUgMy41VjEuNUgxM1YzLjVIMTAuOTdWMS41SDguOTdWMy42Mkw4LjEgNi41SDE1LjlaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const TempleHindu = createIcon('TempleHindu', [
  ['path', { d: 'M6.6 11.5H17.4L16.5 8.5H7.5L6.6 11.5Z', key: '5f1vdo' }],
  ['path', { d: 'M20 11.5V13.5H4V11.5H2V22.5H10V17.5H14V22.5H22V11.5H20Z', key: '1k3uni' }],
  ['path', { d: 'M15.9 6.5L15 3.5V1.5H13V3.5H10.97V1.5H8.97V3.62L8.1 6.5H15.9Z', key: '1014ot' }],
]);

export default TempleHindu;
